import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PhoneNumberListComponent } from "./phone-number-list.component";
import { SelectionListDeluxeModule } from "@onsip/web/features/shared/components/pickers/selectionListDeluxe/selection-list-deluxe.module";
import { MatListModule } from "@angular/material/list";
import { PipesModule } from "@onsip/web/features/shared/pipes/pipes.module";
import { ReactiveFormsModule } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { TranslateModule } from "@ngx-translate/core";
import { AddPhoneNumberDialogModule } from "@onsip/web/features/administrators/phoneNumbers/addPhoneNumberDialog/add-phone-number-dialog.module";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";

@NgModule({
  declarations: [PhoneNumberListComponent],
  exports: [PhoneNumberListComponent],
  imports: [
    CommonModule,
    SelectionListDeluxeModule,
    MatListModule,
    PipesModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    TranslateModule,
    AddPhoneNumberDialogModule,
    MatButtonModule,
    MatIconModule
  ]
})
export class PhoneNumberListModule {}
